var _title, _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgWhatsappIcon = function SvgWhatsappIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "38px",
    viewBox: "0 0 38 38",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "whatsapp_icon copy")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-17.5%",
    y: "-17.5%",
    width: "135.0%",
    height: "135.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0.5,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "75.578604%",
    y1: "0%",
    x2: "42.8656346%",
    y2: "92.5880607%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D34C",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B819",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "whatsapp_icon-copy",
    filter: "url(#filter-1)",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0000093,27.2727273 C12.768606,27.2727273 10.5372028,26.7106176 8.67770004,25.5863983 L8.30579949,25.3990285 L3.65702409,26.7106176 L4.95869459,22.2137405 L4.58679405,21.6516308 C3.28512354,19.5905621 2.72727273,17.3421235 2.72727273,15.0936849 C2.72727273,8.34836919 8.30579949,2.72727273 15.0000093,2.72727273 C18.3471142,2.72727273 21.3223186,4.0388619 23.7396721,6.28730049 C26.1570256,8.72310895 27.2727273,11.7210271 27.2727273,15.0936849 C27.2727273,21.6516308 21.8801694,27.2727273 15.0000093,27.2727273 Z",
    id: "Path",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5,4.3125 C22.6875,1.5 18.9375,0 15,0 C6.75,0 0,6.75 0,15 C0,17.625 0.75001875,20.25 2.06251875,22.5 L0,30 L7.875,27.9375 C10.125,29.0625 12.5625,29.8125 15,29.8125 C23.25,29.8125 30,23.0625 30,14.8125 C30,10.875 28.3125,7.125 25.5,4.3125 Z M15,27.375 C12.75,27.375 10.5,26.8125 8.625,25.6875 L8.25,25.5 L3.56248125,26.8125 L4.875,22.3125 L4.5,21.75 C3.18748125,19.6875 2.62498125,17.4375 2.62498125,15.1875 C2.62498125,8.4375 8.25,2.8125 15,2.8125 C18.375,2.8125 21.375,4.125 23.8125,6.375 C26.25,8.8125 27.375,11.8125 27.375,15.1875 C27.375,21.75 21.9375,27.375 15,27.375 Z M21.75,18 C21.375,17.8125 19.5,16.875 19.125,16.875 C18.75,16.6875 18.5625,16.6875 18.375,17.0625 C18.1875,17.4375 17.4375,18.1875 17.25,18.5625 C17.0625,18.75 16.875,18.75 16.5,18.75 C16.125,18.5625 15,18.1875 13.5,16.875 C12.375,15.9375 11.625,14.625 11.4375,14.25 C11.25,13.875 11.4375,13.6875 11.625,13.5 C11.8125,13.3125 12,13.125 12.1875,12.9375 C12.375,12.75 12.375,12.5625 12.5625,12.375 C12.75,12.1875 12.5625,12 12.5625,11.8125 C12.5625,11.625 11.8125,9.75 11.4375,9 C11.25,8.4375 10.875,8.4375 10.6875,8.4375 C10.5,8.4375 10.3125,8.4375 9.9375,8.4375 C9.75,8.4375 9.375,8.4375 9,8.8125 C8.625,9.1875 7.6875,10.125 7.6875,12 C7.6875,13.875 9,15.5625 9.1875,15.9375 C9.375,16.125 11.8125,20.0625 15.5625,21.5625 C18.75,22.875 19.3125,22.5 20.0625,22.5 C20.8125,22.5 22.3125,21.5625 22.5,20.8125 C22.875,19.875 22.875,19.125 22.6875,19.125 C22.5,18.1875 22.125,18.1875 21.75,18 Z",
    id: "Shape",
    fill: "#FFFFFF"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhatsappIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/whatsapp_icon.25f7a6b6.svg";
export { ForwardRef as ReactComponent };